import React, { useContext, useEffect, useState } from 'react'
import { MapContext } from '../../component'
import mapboxgl from 'mapbox-gl'

export const AttributionControl = ({
  options = {
    compact: false
  },
  position,
  getControl
}: {
  options?: {
    compact?: boolean
    customAttribution?: string | string[]
  }
  position?: controlPositions
  getControl?: (a: mapboxgl.AttributionControl) => void
}) => {
  const map = useContext(MapContext)
  const [control, setControl] = useState<mapboxgl.AttributionControl | null>(
    null
  )

  useEffect(() => {
    if (!map) return
    if (control) map.removeControl(control)
    const newcontrol = new mapboxgl.AttributionControl(options)
    map.addControl(newcontrol, position)
    if (getControl) getControl(newcontrol)
    setControl(newcontrol)
  }, [])
  return null
}
